import React from 'react';
import { isEmpty } from 'lodash';
import { SaveToListPopover, SaveToListButton as BaseSaveToListButton } from '@fiverr-private/collect_actions';

interface SaveToListProps {
    sellerId?: string | number;
}

export const SaveToListButton = ({ sellerId }: SaveToListProps) => {
    if (!sellerId) {
        return null;
    }

    return (
        <SaveToListPopover
            resourceType="SELLER"
            resourceId={String(sellerId)}
            position="bottom-end"
            fullWidth
            renderTrigger={({ inCollections }) => (
                <BaseSaveToListButton variant="labeled" checked={!isEmpty(inCollections)} />
            )}
        />
    );
};
